/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsUpdateProductionStatus
 */
export interface MelcoFusionModelsUpdateProductionStatus {
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsUpdateProductionStatus
     */
    production_status?: number;
}

export function MelcoFusionModelsUpdateProductionStatusFromJSON(json: any): MelcoFusionModelsUpdateProductionStatus {
    return MelcoFusionModelsUpdateProductionStatusFromJSONTyped(json, false);
}

export function MelcoFusionModelsUpdateProductionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsUpdateProductionStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production_status': !exists(json, 'production_status') ? undefined : json['production_status'],
    };
}

export function MelcoFusionModelsUpdateProductionStatusToJSON(value?: MelcoFusionModelsUpdateProductionStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production_status': value.production_status,
    };
}


